import PropTypes from 'prop-types';
import { useState } from 'react';
import { Icon } from '@iconify/react';
// material
import {
  Typography,
  Box,
  Card,
  BottomNavigation,
  BottomNavigationAction,
  CardContent
} from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineDot
} from '@mui/lab';
import { useTranslation } from '../../common/LocalizationProvider';

// utils
// ----------------------------------------------------------------------
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

// ----------------------------------------------------------------------

OrderItem.propTypes = {
  item: PropTypes.object,
  isLast: PropTypes.bool
};

function OrderItem({ item, isLast }) {
  const t = useTranslation();
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot
          sx={{
            bgcolor:
              (item.type === 'landing' && 'primary.main') ||
              (item.type === 'takeOff' && 'success.main') ||
              (item.type === 'flight' && 'info.main') ||
              (item.type === 'roulage' && 'warning.main') ||
              'error.main'
          }}
        />
        {isLast ? null : <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <Typography variant="subtitle1">{item.title}</Typography>
        {item.type === 'landing' && (
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {`${t('DB_Landing_S')}: ${item.landing}`}
          </Typography>
        )}
        {item.type === 'landing' && (
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {`${t('DB_Touché')}: ${item.toucher}`}
          </Typography>
        )}
        {item.type === 'takeOff' && (
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {`${t('DB_TakeOff_S')}: ${item.takeOff}`}
          </Typography>
        )}
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {`${t('DB_SpeedAlert')}: ${item.speedAlert}`}
        </Typography>
        {item.type === 'landing' && (
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {`${t('DB_SpeedWarning')}: ${item.speedAlert}`}
          </Typography>
        )}
        {item.type !== 'takeOff' && (
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {`${t('DB_GAlert')}: ${item.gAlert}`}
          </Typography>
        )}
        {(item.type === 'landing' || item.type === 'roulage') && (
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {`${t('DB_GWarning')}: ${item.gWarning}`}
          </Typography>
        )}
      </TimelineContent>
    </TimelineItem>
  );
}

// ----------------------------------------------------------------------

PointsItem.propTypes = {
  item: PropTypes.object,
  isLast: PropTypes.bool
};

function PointsItem({ item, isLast }) {
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot
          sx={{
            bgcolor: 'secondary.main'
          }}
        />
        {isLast ? null : <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <Typography variant="subtitle1">{item.value}</Typography>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {item.title}
        </Typography>
      </TimelineContent>
    </TimelineItem>
  );
}

// ----------------------------------------------------------------------

ReportClubOrderTimeline.propTypes = {
  id: PropTypes.number,
  summaryPilot: PropTypes.array
};
export default function ReportClubOrderTimeline({ id, summaryPilot }) {
  const t = useTranslation();
  const [valueTab, setValueTab] = useState(0);
  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const TIMELINES = [
    {
      title: t('DB_Landing_S'),
      landing: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.atterrissages;
        }
        return result;
      }, 0),
      toucher: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.touchers;
        }
        return result;
      }, 0),
      speedAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertSpeedAtterrisssage;
        }
        return result;
      }, 0),
      speedWarning: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.warningSpeedAtterrisssage;
        }
        return result;
      }, 0),
      gAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertgAtterrisssage;
        }
        return result;
      }, 0),
      gWarning: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.warninggAtterrisssage;
        }
        return result;
      }, 0),
      type: 'landing'
    },
    {
      title: t('DB_TakeOff_S'),
      takeOff: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.decollage;
        }
        return result;
      }, 0),
      speedAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertSpeedDecollage;
        }
        return result;
      }, 0),
      type: 'takeOff'
    },
    {
      title: t('DB_Flight_S'),
      speedAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertSpeedVol;
        }
        return result;
      }, 0),
      gAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertgVol;
        }
        return result;
      }, 0),
      restrictedZone: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertGeofence;
        }
        return result;
      }, 0),
      type: 'flight'
    },
    {
      title: t('DB_Taxiing_S'),
      speedAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertSpeedRoulage;
        }
        return result;
      }, 0),
      gAlert: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.alertgRoulage;
        }
        return result;
      }, 0),
      gWarning: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.warninggRoulage;
        }
        return result;
      }, 0),
      type: 'roulage'
    }
  ];

  const TIMELINES_POINTS = [
    {
      title: `${t('Point_New_AD')}: ${
        summaryPilot.reduce((result, report) => {
          if (id === report.piloteId) {
            result = report.pointNewAD;
          }
          return result;
        }, 0) / 30
      } x 30 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointNewAD;
        }
        return result;
      }, 0)
    },
    {
      title: `${t('Point_Trip')}: ${
        summaryPilot.reduce((result, report) => {
          if (id === report.piloteId) {
            result = report.pointTrip;
          }
          return result;
        }, 0) / 10
      } x 10 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointTrip;
        }
        return result;
      }, 0)
    },
    {
      title: `${t('Point_Alert')}: ${
        summaryPilot.reduce((result, report) => {
          if (id === report.piloteId) {
            result = report.pointAlert;
          }
          return result;
        }, 0) / 10
      } x 10 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointAlert;
        }
        return result;
      }, 0)
    },
    {
      title: `${t('Point_Landing')}: ${
        summaryPilot.reduce((result, report) => {
          if (id === report.piloteId) {
            result = report.pointLanding;
          }
          return result;
        }, 0) / 5
      } x 5 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointLanding;
        }
        return result;
      }, 0)
    },
    {
      title: `${t('Point_Perfect_Landing')}: ${
        summaryPilot.reduce((result, report) => {
          if (id === report.piloteId) {
            result = report.pointPerfectLanding;
          }
          return result;
        }, 0) / 5
      } x 5 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointPerfectLanding;
        }
        return result;
      }, 0)
    },
    {
      title: `${t('Point_Bonus')}: ${
        summaryPilot.reduce((result, report) => {
          if (id === report.piloteId) {
            result = report.pointBonus;
          }
          return result;
        }, 0) / 25
      } x 25 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointBonus;
        }
        return result;
      }, 0)
    },
    {
      title: `${t('Point_Remarquable_Trace')}: ${summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointRemarquableTrace;
        }
        return result;
      }, 0)} x 200 points`,
      value: summaryPilot.reduce((result, report) => {
        if (id === report.piloteId) {
          result = report.pointRemarquableTrace;
        }
        return result;
      }, 0)
    }
  ];
  return (
    <Card
      sx={{
        '& .MuiTimelineItem-missingOppositeContent:before': {
          display: 'none',
          backgroundColor: 'transparent'
        },
        height: 600
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} position="center">
        <BottomNavigation showLabels value={valueTab} onChange={handleChangeTab}>
          <BottomNavigationAction
            icon={<Icon icon="healthicons:award-trophy-outline" width={24} height={24} />}
          />
          <BottomNavigationAction
            icon={<Icon icon="akar-icons:triangle-alert" width={24} height={24} />}
          />
        </BottomNavigation>
      </Box>
      <CardContent>
        <TabPanel value={valueTab} index={0}>
          <Timeline>
            {TIMELINES_POINTS.map((item, index) => (
              <PointsItem
                key={item.title}
                item={item}
                isLast={index === TIMELINES_POINTS.length - 1}
              />
            ))}
          </Timeline>
        </TabPanel>
        <TabPanel value={valueTab} index={1}>
          <Timeline>
            {TIMELINES.map((item, index) => (
              <OrderItem key={item.title} item={item} isLast={index === TIMELINES.length - 1} />
            ))}
          </Timeline>
        </TabPanel>
      </CardContent>
    </Card>
  );
}
